import { ChevronDownIcon } from "@heroicons/react/24/outline";
import { Select } from "@/components/ui/select/select";
import { SelectItem } from "@/components/ui/select/select-item";

const METRICS = ["Hook", "Visual ease", "Hold"];

/*
 * VideoReportsSkeleton component
 * Skeleton component used while a video study is processing, anticipating the video reports layout
 */
export const VideoReportsSkeleton = () => {
  /* Render */
  return (
    <div className="flex flex-col gap-4">
      {/* Summary */}
      <div className="flex flex-col gap-3">
        <div className="flex items-center gap-1">
          <ChevronDownIcon className="size-4" />
          <h2 className="text-base font-semibold opacity-70">Summary</h2>
        </div>

        <div className="flex gap-4">
          <div className="flex flex-col gap-2 flex-1">
            {Array.from({ length: 4 }).map((_, index) => (
              <div key={index} className="skeleton h-9 w-full rounded-lg" />
            ))}
          </div>
          <div className="card bg-base-200 rounded-2xl w-[433px] p-4 flex flex-col gap-3">
            {Array.from({ length: 2 }).map((_, index) => (
              <div key={index} className="flex flex-col gap-2">
                <div className="flex items-center justify-between">
                  <div className="skeleton h-4 w-20 rounded-lg" />
                  <div className="skeleton h-4 w-20 rounded-lg" />
                </div>
                <div className="skeleton h-2 w-full rounded-lg" />
                <div className="flex">
                  <div className="skeleton h-3 w-20 rounded-lg" />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Attention comparison */}
      <div className="flex flex-col gap-2">
        <p>How each video compares on Attention:</p>
        <div className="skeleton h-2 w-full rounded-lg" />
        <div className="flex flex-row gap-4">
          {Array.from({ length: 4 }).map((_, index) => (
            <div key={index} className="flex flex-row items-center gap-2">
              <div className="skeleton size-3 rounded-full" />
              <div className="skeleton h-3 w-20 rounded-lg" />
            </div>
          ))}
        </div>
      </div>

      <div className="divider m-0" />

      {/* Assets */}
      <div className="flex flex-col gap-3">
        <div className="flex items-center justify-between">
          <h2 className="text-base font-semibold opacity-70">Assets</h2>
          <Select defaultValue="desc" onChange={() => {}} disabled>
            <SelectItem value="desc">Sort by: Highest score</SelectItem>
            <SelectItem value="asc">Sort by: Lowest score</SelectItem>
          </Select>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-3 gap-3">
          {Array.from({ length: 3 }).map((_, index) => (
            <div key={index} className="card bg-base-100 border-2 border-base-300 rounded-2xl">
              {/* Media placeholder with play button */}
              <div className="skeleton min-h-44 max-h-44 w-full rounded-t-2xl rounded-b-none flex items-center justify-center"></div>

              {/* Content */}
              <div className="px-4 py-5 flex flex-col gap-4">
                <div className="flex items-center justify-between">
                  <p className="font-semibold">Attention</p>
                  <div className="skeleton h-4 w-8 rounded-full" />
                </div>

                {METRICS.map((metric) => (
                  <div key={metric} className="flex items-center justify-between gap-2">
                    <p className="opacity-70 text-sm">{metric}</p>
                    <div className="skeleton h-4 w-2/5 rounded-lg" />
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
